module.exports = __webpack_public_path__ + "img/emp_req.ab8f0228.png";